export enum EmployeeRole {
  qltkmem_cap_nhat = 'QLTKMEM_CAP_NHAT',
  qltkmem_them = 'QLTKMEM_THEM',
  qltkmem_xem_chi_tiet = 'QLTKMEM_XEM_CHI_TIET',
  qltkmem_xem_danh_sach = 'QLTKMEM_XEM_DANH_SACH',
}

export enum PermissionRole {
  qlq_cap_nhat = 'QLQ_CAP_NHAT',
  qlq_them = 'QLQ_THEM',
  qlq_xem_chi_tiet = 'QLQ_XEM_CHI_TIET',
  qlq_xem_danh_sach = 'QLQ_XEM_DANH_SACH',
}

export enum TeamRole {
  qln_cap_nhat = 'QLN_CAP_NHAT',
  qln_them = 'QLN_THEM',
  qln_xem_danh_sach = 'QLN_XEM_DANH_SACH',
}
